import type React from 'react'

import liveLayouts from '../../../../slide-schemas/generated/slide-layouts.json'
import type { FindingExhibitData } from './types'

type Rect = { x: number; y: number; w: number; h: number }
type Slot = { rect: Rect }
const livePresets = liveLayouts.presets as unknown as Partial<Record<FindingExhibitData['type'], { slots: Record<string, Slot> }>>

export function exhibitRect(type: FindingExhibitData['type'], slot: string): Rect {
  const preset = livePresets[type]
  const rect = preset?.slots[slot]?.rect
  if (!rect) throw new Error(`Missing exhibit slot ${type}.${slot}`)
  return rect
}

export function exhibitSlot(type: FindingExhibitData['type'], slot: string, originY = 0): React.CSSProperties {
  const rect = exhibitRect(type, slot)
  return { position: 'absolute', left: rect.x, top: rect.y - originY, width: rect.w, height: rect.h }
}

/** Content origin comes from declared geometry, including rail/multiples offsets. */
export function exhibitContentOrigin(type: FindingExhibitData['type']): number {
  const slots = livePresets[type]?.slots
  if (!slots) throw new Error(`Missing exhibit layout ${type}`)
  return Math.min(...Object.entries(slots)
    .filter(([name]) => !['header', 'headline', 'supportingText'].includes(name))
    .map(([, slot]) => slot.rect.y))
}
